import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '5.875rem',
    height: '1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#656565',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.312rem',
  },
}));

export default function Status(props) {
  const classes = useStyles();
  const { children, status } = props;
  const colors = {
    0: { background: '#ebebeb', color: '#656565' },
    1: { background: '#d4f9f1', color: '#0e886c' },
    2: { background: '#e0e1ff', color: '#3f44be' },
    3: { background: '#ffe1e1', color: '#bf4442' },
  };
  return (
    <div className={classes.root} style={colors[status]}>
      {children}
    </div>
  );
}
